import cn from "classnames";

import React from "react";

import { Accordion, AccordionSummary, Box, Grid, Skeleton } from "@mui/material";

import usePlatform from "@/hooks/usePlatform";

import { ProInfoUseInFlight } from "../ProInfo";

const SkeletonItem = () => {
  const { isMobile } = usePlatform();

  return (
    <Accordion>
      <AccordionSummary>
        <Box className="w-full">
          <Grid container className="w-full" spacing={1} alignItems="center">
            <Grid item xs={12} sm>
              <div className="flex items-center">
                <Skeleton variant="rounded" width={38} height={38} className="mr-[15px]" />
                <div className="ml-[10px]">
                  <Skeleton width={160} animation="wave" />
                  <Skeleton width={160} height={20} animation="wave" />
                  {isMobile ? (
                    <>
                      <Skeleton width={160} height={20} animation="wave" />
                      <Skeleton width={160} height={20} animation="wave" />
                    </>
                  ) : null}
                </div>

                {isMobile ? (
                  <div className="flex flex-1 justify-end">
                    <Skeleton variant="circular" width={36} height={36} animation="wave" />
                  </div>
                ) : null}
              </div>
            </Grid>

            {isMobile ? null : (
              <Grid item xs={12} sm>
                <Box className="flex flex-col items-center">
                  <Skeleton width={140} animation="wave" />
                  <Skeleton width={140} height={20} animation="wave" />
                </Box>
              </Grid>
            )}

            <Grid item xs={12} sm>
              <Box className={cn("flex items-center", { "justify-end": !isMobile })}>
                <Box
                  className="inline-flex rounded-[6px] p-[8px] mr-[20px]"
                  sx={{ backgroundColor: (theme) => theme.palette.action.hover }}
                >
                  <Box className="flex flex-col">
                    <Skeleton width={100} animation="wave" className="mb-[4px]" />
                    <Skeleton width={100} animation="wave" className="mb-[4px]" />
                    <Skeleton width={100} animation="wave" />
                  </Box>

                  <Box className="flex flex-col ml-[15px]">
                    <Skeleton width={100} animation="wave" className="mb-[4px]" />
                    <Skeleton width={100} animation="wave" className="mb-[4px]" />
                  </Box>
                </Box>

                {isMobile ? null : (
                  <Skeleton variant="circular" width={36} height={36} animation="wave" />
                )}
              </Box>
            </Grid>
          </Grid>
        </Box>
      </AccordionSummary>
    </Accordion>
  );
};

const FlightListSkeleton = ({ count, showPro }: { count: number; showPro?: boolean }) => {
  if (count > 10) return null;

  return (
    <div className="pt-[20px]">
      {count === 0 ? (
        <div className="flex items-center justify-between pb-[20px]">
          <Skeleton variant="rounded" width={100} height={25} />
          <Skeleton variant="rounded" width={100} height={25} />
        </div>
      ) : null}

      {showPro && <ProInfoUseInFlight />}
      {new Array(6).fill("").map((_, i) => (
        <SkeletonItem key={i} />
      ))}
    </div>
  );
};

export default React.memo(FlightListSkeleton);
